export const filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {},
    },
    {
        fieldType: 'input',
        label: 'Terminal Name',
        name: 'name',
        props: {
            placeholder: 'Enter Terminal Name',
        },
    },
    {
        fieldType: 'input',
        label: 'Terminal ID',
        name: 'terminalId',
        props: {
            placeholder: 'Enter Terminal ID',
        },
    },
    {
        fieldType: 'search-select',
        label: 'Merchant Name',
        name: 'merchantId',
        props: {
            data: [],
            label: 'Select Merchant',
            labelField: 'name',
            valueField: 'entityCode',
            entityType: 'MERCHANT',
        },
    },
    {
        fieldType: 'select',
        label: 'Status',
        name: 'status',
        props: {
            placeholder: 'Select Status',
            data: [
                { name: 'Active', value: 'ACTIVE' },
                { name: 'Inactive', value: 'INACTIVE' },
                {
                    name: 'Inactive with settlement',
                    value: 'INACTIVE_WITH_SETTLEMENT',
                },
            ],
            labelField: 'name',
            valueField: 'value',
            label: 'Select Status',
        },
    },
];
